function imageDataToPixelChannelRows(imageData: ImageData, brickSize: number) {
	const ceilBrickSize = Math.ceil(brickSize);
	const pixelRows = new Array(ceilBrickSize);
	for (let j = 0; j < ceilBrickSize; j++) {
		pixelRows[j] = imageData.data.subarray(
			j * ceilBrickSize * 4,
			j * ceilBrickSize * 4 + ceilBrickSize * 4,
		);
	}
	return pixelRows;
}

export { imageDataToPixelChannelRows };
